<template>
    <div>
        <van-nav-bar
                title="修改站点"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />
        <van-steps :active="active">
            <van-step>填写站点信息</van-step>
            <van-step>选择模板</van-step>
            <van-step>完成</van-step>
        </van-steps>
        <van-cell-group v-if="step === 1">
            <van-field
                    v-model="siteInfo.site_name"
                    required
                    clearable
                    label="站点名称"
                    placeholder="请输入站点名称"
            />
            <van-row type="flex" justify="center">
                <van-col class="btn-create">
                    <van-button type="primary" @click="onClickStep2">下一步</van-button>
                </van-col>
            </van-row>
        </van-cell-group>

        <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad" v-else-if="step === 2">
            <van-row>
                <van-col v-for="(item,index) in list" :key="item.id" :index="index" :class="{'even':(index+1)%2==0,'list-item':true}">
                    <img :src="item.preview_img" class="list-img" @click="onClickPreview"/>
                    <van-popup v-model="show">
                        <img :src="item.preview_img" class="list-img"/>
                        <div class="item-action">
                            <a href="javascript:;" @click="onClickUse(item.id,item.template_name)">立即使用</a>
                        </div>
                    </van-popup>
                </van-col>
            </van-row>
        </van-list>

        <msg title="修改成功" description="请到站点列表查看站点信息" :buttons="buttons" :icon="icon" v-else></msg>

    </div>
</template>

<script>
    import {Field,NavBar,Cell,CellGroup,Button,Row,Col,Steps,Step,List,Toast,Popup,Dialog} from 'vant';

    export default {

        name: "Create",
        components:{
            Msg,
            XButton,
            [Field.name]:Field,
            [NavBar.name]:NavBar,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            [Button.name]:Button,
            [Row.name]:Row,
            [Col.name]:Col,
            [Steps.name]:Steps,
            [Step.name]:Step,
            [List.name]:List,
            [Toast.name]:Toast,
            [Popup.name]:Popup,
            [Dialog.name]:Dialog
        },
        data(){
            return {
                active:0,
                template_id:0,
                password:'',
                step:1,
                list: [],
                loading: false,
                finished: false,
                show:false,
                description: '',
                icon: '',
                buttons: [{
                    type: 'primary',
                    text: '返回站点列表',
                    link: '/mobile/site/index'
                }],
                siteInfo:{}
            }
        },
        created:function () {
            var _this = this
            this.$http.get('/v1/sites/view?siteId='+this.$route.query.id).then((res)=>{
                _this.siteInfo = res.data.result;
            });
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickStep2(){
                if (!this.siteInfo.site_name){
                    Dialog.alert({
                        message:'站点名称不能为空'
                    });
                    return false;
                }
                this.step = 2;
                this.active = 1;
            },
            onLoad() {
                var _this = this;
                this.$http.get('/v1/site-template/index').then(function (res) {
                    _this.list = res.data;

                });
                _this.loading = false;
                _this.finish = true;
            },
            onClickUse(id,name){
                //Toast.success('使用成功');
                this.show = false;
                this.step = 3;
                this.active = 2;
                this.template_id = id;
                this.$http.patch('/v1/sites/'+this.$route.query.id,{site_name:this.siteInfo.site_name,template_id:this.template_id,template_name:name});
            },
            onClickPreview(){
                this.show = true;
            }
        }
    }
</script>

<style scoped>
    .btn-create{
        margin: 20px 0;
    }
    .list-img{
        width: 100%;
    }
    .list-item{
        float: left;
        margin-top: 15px;
        position: relative;
        width: 49%;
    }

    .even{
        margin-left:2%;
    }

    .item-action{
        width: 100%;
        height: 100%;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin: 10px 0;
    }
    .item-action a{
        color: #000;
        font-size: 14px;
    }
    .item-action-show{
        opacity: .7;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;
        -o-transition: opacity 1s;
        transition: opacity 1s;
        visibility: visible;
    }
</style>
